/** One readable message from an API error, including the validation arrays FastAPI returns. */
export const apiError = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length) {
    return detail.map((d) => (d.msg || '').replace(/^Value error, /, '')).join('. ');
  }
  if (err?.response?.status === 401 || err?.response?.status === 403) {
    return 'You need to be signed in as staff to manage the directory.';
  }
  return fallback;
};
